import { getItem } from 'common/api/v1/incentiveOfferElements';

import {
    FETCH_INCENTIVE_OFFER_COMPLEMENTS,
    FETCH_INCENTIVE_OFFER_COMPLEMENTS_FAILURE,
    FETCH_INCENTIVE_OFFER_COMPLEMENTS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default () => (dispatch) =>
    new Promise((resolve) => {
        dispatch(actions[FETCH_INCENTIVE_OFFER_COMPLEMENTS]());

        getItem()
            .then((response) => {
                dispatch(
                    actions[FETCH_INCENTIVE_OFFER_COMPLEMENTS_SUCCESS](
                        response.data,
                    ),
                );
            })
            .catch((error) =>
                dispatch(
                    actions[FETCH_INCENTIVE_OFFER_COMPLEMENTS_FAILURE](
                        error?.response?.data?.errors,
                    ),
                ),
            )
            .finally(resolve);
    });
